<template>
  <div class="alert-modal">
    <div class="modal fade show alert" id="confirmModal" tabindex="-1" aria-labelledby="confirmModal" style="display: block;" aria-modal="true" role="dialog">
      <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable">
        <div class="modal-content">
          <div class="modal-body">
            <div class="font-bold-20 mt-45" v-html="data.title"></div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary btn-md" data-dismiss="modal" ref="alert" @click="confirm" @keydown.enter="confirm">확인</button>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-backdrop fade show"></div>
  </div>
</template>

<script>
export default {
  name: 'Alert',
  props: [
      'data'
  ],
  mounted() {
    this.$refs.alert.focus()
  },
  methods: {
    confirm() {
      if (this.data.confirmEvent) {
        this.data.confirmEvent()
      } else {
        this.$emit('close')
      }
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/alert/Alert.vue